var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-selection",on:{"click":_vm.handleCheckboxClick}},[_c('rcc-checkbox',{attrs:{"value":_vm.isAllSelected,"is-readonly":"","is-indeterminate":_vm.isIndeterminate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }